import { format } from "date-fns";
import { ko } from "date-fns/locale";
import { Estimate, staticLectureClass } from "lib/types";
import { cn } from "lib/utils";
import React, { useState } from "react";

const ResultPage = ({
  estimate,
  isDateSelected,
  classTimes,
}: {
  estimate: Estimate;
  isDateSelected: boolean;
  classTimes: number[];
}) => {
  const [result, setResult] = useState<string>("");

  return (
    <div className="px-10 py-5 bg-gray-100 border rounded-2xl font-normal text-gray-600 space-y-2">
      <div className="flex items-center gap-3">
        <span
          className={cn(
            estimate.classType > 0 ? "text-gray-600" : "text-red-500"
          )}
        >
          {staticLectureClass.find((l) => l.type === estimate.classType)
            ?.name || "[수업 선택되지 않음]"}
        </span>
        <span
          className={cn(
            estimate.schoolName?.trim() !== ""
              ? "text-gray-600"
              : "text-red-500"
          )}
        >
          {estimate.schoolName || "[학교명 미입력]"}
        </span>
      </div>{" "}
      <div className="flex items-center gap-3">
        <span className={cn(isDateSelected ? "text-gray-600" : "text-red-500")}>
          {isDateSelected
            ? format(estimate.classDate, "yyyy년 M월 d일", {
                locale: ko,
              })
            : "[수업날짜 선택되지 않음]"}
        </span>
        <span
          className={cn(
            estimate.contractCnt > 0 ? "text-gray-600" : "text-red-500"
          )}
        >
          {estimate.contractCnt > 0
            ? `${estimate.contractCnt} 학급`
            : "[학급수 미입력]"}
        </span>
        <span
          className={cn(
            classTimes.includes(estimate.classTimes)
              ? "text-gray-600"
              : "text-red-500"
          )}
        >
          {classTimes.includes(estimate.classTimes)
            ? `${estimate.classTimes} 차시`
            : "[수업시간 미입력]"}
        </span>
      </div>
    </div>
  );
};

export default ResultPage;
